export const PAUSE_BLOT_NAME = 'pause'
/**
 * 호환성을 위해 기존 태그명 그대로 사용
*/
export const PAUSE_TAG_NAME = 'div'
export const PAUSE_MODULE_NAME = 'pauseModule'
/**
 * 호환성을 위해 기존 클래스 명 그대로 사용
 */
export const PAUSE_CLASS_NAME = 'pauseButton'
